import { authenticatedFetch } from "./authenticatedFetch";
import type { OrganizationId } from "./accessOrganizations";

const API_BASE = process.env.REACT_APP_API_URL ?? "/api";

export type CurrentSession = {
  user: {
    sub: string;
    name: string;
    email: string;
    locale: string;
    job_title: string;
    user_type?: "client" | "team" | "";
    organizations?: OrganizationId[];
  };
  administrative_level: string | null;
  apps: string[];
  permissions: string[];
  authorization: {
    source: string;
    legacy_fallback: boolean;
    requires_review: boolean;
    administration_access: boolean;
  };
};

export class CurrentSessionError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "CurrentSessionError";
    this.status = status;
  }
}

/**
 * Loads the identity and access resolved by the API after Cognito has
 * authenticated the user. This is the sole source used by the new login flow
 * to decide where a user can go.
 */
export async function getCurrentSession(): Promise<CurrentSession> {
  const response = await authenticatedFetch(`${API_BASE}/me`);
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const detail = (body as { detail?: string; error?: string }).detail ||
      (body as { error?: string }).error ||
      "Não foi possível validar seu acesso.";
    throw new CurrentSessionError(detail, response.status);
  }

  return response.json() as Promise<CurrentSession>;
}
